import { createApp } from 'vue'
import './assets/styles/index.css'
import 'bootstrap'
import './assets/styles/custom.scss';
import './assets/styles/animate.min.css'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import AOS from 'aos'
import 'aos/dist/aos.css'
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faMapMarkerAlt} from "@fortawesome/free-solid-svg-icons";
import { faAngleRight} from "@fortawesome/free-solid-svg-icons";

library.add(faPhone);
library.add(faEnvelope);
library.add(faMapMarkerAlt);
library.add(faAngleRight);

// import Particles from "particles.vue3";
import Swal from 'sweetalert2'

import router from './router'

// AOS: Initialisation globale pour eviter que les elements restent caches
// lors d'une navigation SPA. Une seule initialisation puis un refresh a chaque changement de route.
AOS.init({
    duration: 700,
    once: true,
    offset: 20,
    easing: 'ease-out-cubic'
});

// Refresh AOS apres chaque changement de route (contenu recharge)
router.afterEach(() => {
    // Double timeout pour laisser le temps au DOM + images de se poser
    setTimeout(() => {
        AOS.refreshHard();
        // Deuxieme refresh apres les images lazy
        setTimeout(() => AOS.refresh(), 400);
    }, 50);
});

// router config
//Check login and redirect
router.beforeEach((to, from, next) => {
    // window.scrollTo(0, 0)
    const token = localStorage.getItem("token");
    const isAuthenticated = token && token !== "undefined";
    const roleId = parseInt(localStorage.getItem("role_id") || "0", 10);
    const isClient = roleId === 6;

    // Routes réservées à l'Espace Client
    if (to.matched.some(route => route.meta.requiresClient)) {
        if (!isAuthenticated) {
            return next({ path: "/login", query: { redirect: to.fullPath } });
        }
        if (!isClient) {
            return next({ name: "Home" });
        }
        return next();
    }

    // Un client connecté ne doit pas aller sur les routes candidat classiques
    if (isAuthenticated && isClient && to.matched.some(route => route.meta.requiresAuth) && !to.matched.some(route => route.meta.requiresClient)) {
        return next({ name: "ClientDashboard" });
    }

    if (to.matched.some(route => route.meta.requiresAuth)) {
        if (isAuthenticated) {
            let email_verified = localStorage.getItem("email_verified");
            if (email_verified == "true") {
                next();
            } else {
                // Conserver l'intention apres verification email
                if (to.fullPath && to.fullPath !== "/verify-email") {
                    localStorage.setItem("post_auth_redirect", to.fullPath);
                }
                next({ path: "/verify-email" });
            }
        } else {
            // Rediriger vers login en gardant la destination d'origine
            next({ path: "/login", query: { redirect: to.fullPath } });
        }
    } else if (to.matched.some(route => route.name === "Login")) {
        if (isAuthenticated) {
            if (isClient) {
                next({ name: "ClientDashboard" });
            } else {
                next({ name: "Home" });
            }
        } else {
            next();
        }
    } else {
        next();
    }
    
    // fetch(window.location.origin + "?v=" + Math.floor(Math.random() * 1331))
    //     .then((result) => {
    //         result.text().then(function (text) {
    //             //console.log(document.querySelectorAll('link'));
    //             let prev = document.querySelectorAll('link')[5].getAttribute('link');

    //             const regex = /href="\/js\/app\.([a-z0-9]+)/;
    //             const regex2 = /js\/app\.([a-z0-9]+)/;
    //             const match1 = prev.match(regex2);
    //             const match2 = text.match(regex);
    //             const extractedValue1 = match1 ? match1[1] : null;
    //             const extractedValue2 = match2 ? match2[1] : null;
                
    //             if (extractedValue1 == extractedValue2) {
    //                 // console.log(extractedValue1, extractedValue2)
    //                 //console.log('v=')
    //             } else {
    //                 // console.log('v!')
    //                 // console.log(extractedValue1, extractedValue2)
    //                 window.location.reload();
    //             }
    //         });
    //     })

});


const ToastSuccess = Swal.mixin({
    toast: true,
    icon: "success",
    title: "Opération réussie!",
    position: 'top-end',
    showConfirmButton: false,
    timerProgressBar: true,
    timer: 4000,
    showCloseButton: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

const ToastError = Swal.mixin({
    toast: true,
    icon: "error",
    title: "Une erreur s'est produite!",
    position: 'top-end',
    showConfirmButton: false,
    timerProgressBar: true,
    timer: 4000,
    showCloseButton: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

const ToastWarning = Swal.mixin({
    toast: true,
    icon: "warning",
    title: "Attention !...",
    position: 'top-end',
    showConfirmButton: false,
    timerProgressBar: true,
    timer: 4000,
    showCloseButton: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

const AlertSuccess = Swal.mixin({
    toast: false,
    icon: "success",
    title: "Succès!",
    showConfirmButton: true,
    confirmButtonColor: '#0066b6',
    showCloseButton: true,
})

const AlertError = Swal.mixin({
    toast: false,
    icon: "error",
    title: "Une erreur s'est produite!",
    showConfirmButton: false,
    showCloseButton: true,
})

const AlertWarning = Swal.mixin({
    toast: false,
    icon: "warning",
    title: "Attention!",
    showConfirmButton: false,
    showCloseButton: true,
})

const ShowLoader = (text = '') => {
    document.getElementById("appLoader").classList.add('d-block')
    document.getElementById("appLoader").classList.remove('d-none')
    document.getElementById("loaderText").textContent = text + ''
}

const HideLoader = () => {
    document.getElementById("appLoader").classList.remove('d-block')
    document.getElementById("appLoader").classList.add('d-none')
}

const currentYearUrl = process.env.VUE_APP_API_ENDPOINT + "/api/current-year"

//axios config
axios.defaults.headers.common["Authorization"] = localStorage.getItem("token")
    ? "Bearer " + localStorage.getItem("token")
    : "";
axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT + "/api/candidate";

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    // Ne pas montrer le loader pour les requêtes publiques
    if (!config.url.includes('/jobs') && !config.url.includes('/candidate/jobs') && !config.url.includes('/trainings')) {
        ShowLoader()
    }
    return config;
});

// Add a response interceptor
axios.interceptors.response.use(
    function (response) {
        // Ne pas cacher le loader pour les requêtes publiques
        if (!response.config.url.includes('/jobs') && !response.config.url.includes('/candidate/jobs') && !response.config.url.includes('/trainings')) {
            HideLoader()
        }
        return response;
    },
    function (error) {
        // Ne pas cacher le loader pour les requêtes publiques
        if (!error.config?.url?.includes('/jobs') && !error.config?.url?.includes('/candidate/jobs') && !error.config?.url?.includes('/trainings')) {
            HideLoader()
        }
        if (error.response && error.response.status == 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("candidature_step");
            localStorage.setItem("session_expired", "true");
            // Preserver la destination actuelle pour y revenir apres reconnexion
            const currentPath = window.location.pathname + window.location.search;
            if (currentPath && currentPath !== "/login" && !currentPath.startsWith("/login")) {
                router.push({ path: "/login", query: { redirect: currentPath } });
            } else {
                router.push("login");
            }
        }
        if (error.toJSON().message === "Network Error") {
            ToastError.fire({
                title:
                    "Pas de connexion au serveur. Vérifier votre connexion internet et réessayer."
            });
        }
        return Promise.reject(error);
    }
);

const app = createApp(App).use(router)
app.use(VueAxios, axios)
app.provide('axios', axios)
.component('font-awesome-icon', FontAwesomeIcon)

import store from './store'

app.use(store)

// app.use(Particles)
app.provide('ToastSuccess', ToastSuccess)
app.provide('ToastError', ToastError)
app.provide('ToastWarning', ToastWarning)
app.provide('AlertError', AlertError)
app.provide('AlertWarning', AlertWarning)
app.provide('AlertSuccess', AlertSuccess)
app.provide('currentYearUrl', currentYearUrl)
app.provide('ShowLoader', ShowLoader)
app.provide('HideLoader', HideLoader)
app.provide('NewSession', true)
// app.provide('authBaseUrl', authBaseUrl)
app.mount('#app')
